import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import businessModelActions from '../actions/businessModel';

function getPreferredBusinessModel(store, action) {
    const { systemId } = action.payload;

    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?systemId=${systemId}`)
        .end((error, response) => {
            store.dispatch(actions.enableLoadOverLay(false));

            if (error) {
                store.dispatch(businessModelActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const res = JSON.parse(response.text);
                const businessModelType = res.businessModel;
                store.dispatch(businessModelActions.getPreferredBusinessModelSuccess(businessModelType));
            } catch (exp) {
                store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default getPreferredBusinessModel;
